export default __webpack_public_path__ + "static/media/bayer_logo.399af18d.svg";